import { Link } from "wouter";
import { Mail, Phone, User } from "lucide-react";
import { ReachItem } from "./ReachItem";
import type { RailPerson } from "./RailPeople";
import { primaryContact } from "./recordFormat";

/** A company's header reach: who to call (the primary person) and how, plus the company's main line. */
export function CompanyReach({ people, mainPhone }: { people: RailPerson[]; mainPhone?: string | null }) {
  const p = primaryContact(people);
  return (
    <>
      {p && (
        <Link
          href={`/contacts/${p.id}`}
          className="inline-flex max-w-full items-center gap-1.5 rounded-md border bg-card px-2 py-0.5 text-[12.5px] font-semibold hover:underline [&>svg]:h-3.5 [&>svg]:w-3.5 [&>svg]:shrink-0 [&>svg]:text-muted-foreground"
        >
          <User />
          <span className="truncate">{p.name}</span>
          {p.title && <span className="truncate font-normal text-muted-foreground">{p.title}</span>}
        </Link>
      )}
      {p?.email && <ReachItem icon={<Mail />} value={p.email} />}
      {p?.phone && <ReachItem icon={<Phone />} value={p.phone} />}
      {mainPhone && mainPhone !== p?.phone && <ReachItem icon={<Phone />} value={mainPhone} label="Main" />}
    </>
  );
}
